type SortButtonProps = {
  sort: boolean;
  onChangeSort: () => void;
}

function SortButton({ sort, onChangeSort }: SortButtonProps) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="20"
      viewBox="0 0 36 20"
      fill="none"
      className="cursor-pointer"
      onClick={onChangeSort}
    >
      <rect width="36" height="20" rx="2" fill="#F3F4F6" />
      <path
        d="M11.5768 2.63477L11.2998 12.8194H8.70034L8.41625 2.63477L11.5768 2.63477ZM10.0001 17.3649C9.5313 17.3649 9.12884 17.1992 8.79267 16.8677C8.45649 16.5315 8.29077 16.1291 8.29551 15.6603C8.29077 15.1963 8.45649 14.7986 8.79267 14.4672C9.12884 14.1357 9.5313 13.97 10.0001 13.97C10.4499 13.97 10.8452 14.1357 11.1861 14.4672C11.527 14.7986 11.6999 15.1963 11.7046 15.6603C11.6999 15.9728 11.617 16.2593 11.456 16.5197C11.2998 16.7754 11.0938 16.9814 10.8381 17.1376C10.5824 17.2891 10.3031 17.3649 10.0001 17.3649Z"
        fill={sort ? '#00629B' : '#9CA3AF'}
      />
      <path
        d="M21.7667 14.3742V15.179L22.3357 14.6099L23.9023 13.0433C23.9989 12.9627 24.1491 12.9623 24.2462 13.0421C24.3341 13.1366 24.3318 13.2711 24.2393 13.3635L21.8742 15.7286C21.7568 15.8261 21.6357 15.8659 21.525 15.8659C21.3768 15.8659 21.2655 15.8183 21.1857 15.7385L18.8107 13.3635C18.7159 13.2687 18.7159 13.1297 18.8107 13.0349C18.9055 12.9401 19.0445 12.9401 19.1393 13.0349L20.7143 14.6099L21.2833 15.179V14.3742V4.27422C21.2833 4.13331 21.3841 4.03255 21.525 4.03255C21.6566 4.03255 21.7667 4.14886 21.7667 4.27422V14.3742Z"
        fill={sort ? '#00629B' : '#9CA3AF'}
        stroke={sort ? '#00629B' : '#9CA3AF'}
        strokeWidth="0.666667"
      />
      <path
        d="M27.925 15.1738H26.7C26.4 15.1738 26.15 15.4238 26.125 15.7238C26.125 16.0238 26.375 16.2988 26.675 16.2988H27.9C28.2 16.2988 28.45 16.0488 28.475 15.7488C28.475 15.4238 28.225 15.1738 27.925 15.1738Z"
        fill={sort ? '#00629B' : '#9CA3AF'}
      />
      <path
        d="M29.825 11.3496H26.7C26.4 11.3496 26.15 11.5996 26.125 11.8996C26.125 12.1996 26.375 12.4746 26.675 12.4746H29.8C30.1 12.4746 30.35 12.2246 30.375 11.9246C30.375 11.5996 30.125 11.3496 29.825 11.3496Z"
        fill={sort ? '#00629B' : '#9CA3AF'}
      />
      <path
        d="M31.1 7.52539H26.7C26.4 7.52539 26.125 7.77539 26.125 8.07539C26.125 8.37539 26.375 8.65039 26.675 8.65039H31.075C31.375 8.65039 31.625 8.40039 31.65 8.10039C31.65 7.77539 31.4 7.52539 31.1 7.52539Z"
        fill={sort ? '#00629B' : '#9CA3AF'}
      />
      <path
        d="M33 3.72461H26.7C26.4 3.72461 26.15 3.97461 26.125 4.27461C26.125 4.57461 26.375 4.84961 26.675 4.84961H32.975C33.275 4.84961 33.525 4.59961 33.55 4.29961C33.575 3.97461 33.3 3.72461 33 3.72461Z"
        fill={sort ? '#00629B' : '#9CA3AF'}
      />
    </svg>
  );
}

export default SortButton;
